import { FC, forwardRef, ReactElement, Ref } from "react";
import { InputText } from "@goodfill/ui-components";
import { DateTime } from "luxon";
import { FocusEventHandler } from "react";

type SignatureBoxProps = {
  promptMessage: ReactElement | string;
  value: string;
  firstName: string;
  lastName: string;
  setValue: (value: string) => void;
  isValid: boolean;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  ref?: Ref<HTMLInputElement>;
  id?: string;
  disabled?: boolean;
};
export const SignatureBox: FC<SignatureBoxProps> = forwardRef(
  ({ promptMessage, firstName, lastName, value, setValue, isValid, onBlur, id, disabled }, ref) => (
    <>
      <div className="flex flex-col">
        <p>{promptMessage}</p>

        <div>
          <strong>Account Title</strong>: {firstName} {lastName}
        </div>
        <div className="mt-9">
          <p className="font-medium">Date: {DateTime.now().toLocaleString(DateTime.DATE_MED)}</p>
        </div>
      </div>
      <InputText
        placeholder={"Sign here"}
        value={value}
        setValue={setValue}
        border={isValid ? "borderDashed" : "red"}
        onBlur={onBlur}
        ref={ref}
        id={id}
        disabled={disabled}
        className="text-center w-full"
      />
    </>
  ),
);
